<div class="modal-box edit-tag-modal" cdkDrag>
    <form class="edit-tag-modal__form modal-form" [formGroup]="editTagForm" (ngSubmit)="onSubmit()">
        <div class="modal-header edit-tag-modal__header" cdkDragHandle>
            <div class="edit-tag-modal__headline modal-headline">
                <span class="edit-tag-modal__eyebrow modal-eyebrow">{{ 'TAGS' | translate }}</span>
                <h4 class="modal-title edit-tag-modal__title modal-heading">{{ (f.id.value ? 'EDIT_TAG' : 'ADD_TAG') | translate }}</h4>
            </div>
            <button type="button" class="edit-tag-modal__close modal-close" [attr.aria-label]="('CLOSE' | translate)" (click)="onCancel()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body edit-tag-modal__body">
            <div class="edit-tag-modal__sections modal-sections">
                <section class="edit-tag-modal__panel modal-panel">
                    <div class="edit-tag-modal__grid modal-grid">
                        <div class="edit-tag-modal__field edit-tag-modal__field--span-2 modal-field">
                            <label class="edit-tag-modal__label modal-label" for="name">{{ 'NAME' | translate }}</label>
                            <input id="name" type="text" class="form-control edit-tag-modal__control modal-control" formControlName="name"
                                [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
                                [placeholder]="('ENTER_TAG_NAME' | translate)">
                            <div *ngIf="submitted && f.name.errors" class="invalid-feedback edit-tag-modal__feedback modal-feedback">
                                <div *ngIf="f.name.errors.required">{{ 'TAG_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-tag-modal__field edit-tag-modal__field--span-2 modal-field">
                            <label class="edit-tag-modal__label modal-label" for="description">{{ 'DESCRIPTION' | translate }}</label>
                            <textarea id="description" rows="4" class="form-control edit-tag-modal__control edit-tag-modal__control--textarea modal-control modal-control--textarea" formControlName="description"
                                [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                                [placeholder]="('ENTER_TAG_DESCRIPTION' | translate)"></textarea>
                            <div *ngIf="submitted && f.description.errors" class="invalid-feedback edit-tag-modal__feedback modal-feedback">
                                <div *ngIf="f.description.errors.required">{{ 'TAG_DESCRIPTION_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-tag-modal__field edit-tag-modal__field--span-2 modal-field">
                            <label class="edit-tag-modal__label modal-label" for="categories">{{ 'CATEGORIES' | translate }}</label>
                            <ng-select id="categories" class="edit-tag-modal__select modal-select"
                                [ngClass]="{ 'is-invalid': submitted && f.categories.errors }"
                                [items]="allCategories" [multiple]="true" [addTag]="addCategoryTag" [hideSelected]="true"
                                [placeholder]="('ENTER_TAG_CATEGORIES' | translate)" formControlName="categories">
                            </ng-select>
                            <div *ngIf="submitted && f.categories.errors" class="invalid-feedback edit-tag-modal__feedback modal-feedback">
                                <div *ngIf="f.categories.errors.required">{{ 'TAG_CATEGORIES_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer edit-tag-modal__footer" cdkDragHandle>
            <div class="edit-tag-modal__actions modal-actions">
                <button type="button" class="red-outline-button edit-tag-modal__button modal-button" (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
                <button type="submit" class="blue-button edit-tag-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
